import React from 'react';
import { NotificationsHeader } from './Header';
import { NotificationsRow } from './Row';
import { Link, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RecordsTable } from 'dyl-components';

const NotficationsTable = ({ onFilter, onPageChange, onOpenNotification, subRoute, tab, onToggleSnoozeModal, snoozedOptions, remove, archive, markRead, snooze, readSchedule, isReadingSchedule, onMarkVoicemailListened }) => {
    const { count, isReadingNotificationHub, hubNotifications = [] } = useSelector(state => state.notifications);
    const [params] = useSearchParams();

    return (
        <RecordsTable
            tableBodyClassName='NotificationsTable'
            isTableLoading={isReadingNotificationHub}
            isSearchResultEmpty={count === 0 && (params.get('search'))}
            isTableEmpty={count === 0 && !(params.get('search'))}
            tableEmptyMessage='No Notifications Displayed'
            TableHeader={<NotificationsHeader onFilter={onFilter} subRoute={subRoute} />}
            TableRows={hubNotifications.map(notification => {
                const notification_details = notification?.notification_details;
                const type = notification.notification_type;
                return (
                    <NotificationsRow
                        key={notification.notification_id}
                        notification={{
                            ...notification,
                            notification_details: {
                                ...(notification_details || {}),
                                description: type === 'assigned_record' ? (
                                    <span>
                                        {notification_details?.description}
                                    </span>
                                ) : notification_details?.description,
                                title: type === 'campaign' ? (
                                    <Link to={`/campaigns/${notification_details?.campaign_id}/dashboard`} target="_blank">
                                        {notification_details?.campaign_name}
                                    </Link>
                                ) : notification_details?.title
                            }
                        }}
                        onOpenNotification={onOpenNotification}
                        tab={tab}
                        onToggleSnoozeModal={onToggleSnoozeModal}
                        snoozedOptions={snoozedOptions}
                        remove={remove}
                        archive={archive}
                        markRead={markRead}
                        snooze={snooze}
                        readSchedule={readSchedule}
                        isReadingSchedule={isReadingSchedule}
                        onMarkVoicemailListened={onMarkVoicemailListened} />
                );
            })}
            recordsCount={count}
            activePage={params.get('page')}
            onPageChange={onPageChange}
            recordsName='Contact'
        />
    )
}

export default NotficationsTable;
